// extracted by mini-css-extract-plugin
export default {"internalUserDetailsFormField":"styles_internalUserDetailsFormField__kp3Qz"};